<div [ngClass]="getClassNames()">
  <ng-content></ng-content>
</div>
